import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import React from "react";

export const StatusChip = ({
  title,
  color,
}: {
  title: string;
  color: string;
}) => {
  return (
    <Chip
      variant="outlined"
      label={
        <Box display="flex" alignItems="center" gap={1}>
          <Box height={10} width={10} borderRadius={20} bgcolor={color} />
          {title}
        </Box>
      }
      size="small"
      sx={{ width: "100%" }}
    />
  );
};
